import React, { createContext, useContext, useLayoutEffect } from "react";

// Çekmece içindeki iç içe katmanlar (onay modal'ı, görsel önizleme) açıkken
// çekmecenin Esc / arka plan kapatması yok sayılır. Katmanlar açık oldukları
// sürece sayaca kaydolur; çekmece onClose'da sayaca bakar.
const NestedOverlayContext = createContext(null);

export function NestedOverlayProvider({ counterRef, children }) {
  return <NestedOverlayContext.Provider value={counterRef}>{children}</NestedOverlayContext.Provider>;
}

// Sağlayıcı yoksa (çekmece dışı kullanım) hiçbir şey yapmaz.
export function useNestedOverlay(open) {
  const counterRef = useContext(NestedOverlayContext);
  useLayoutEffect(() => {
    if (!open || !counterRef) return undefined;
    counterRef.current += 1;
    return () => {
      counterRef.current -= 1;
    };
  }, [open, counterRef]);
}

// Kaydedilmemiş taslaklar (başlık, açıklama, yorum): kirli oldukları sürece kümeye
// kaydolur; çekmece kapanırken küme doluysa onay sorar.
const DirtyDraftContext = createContext(null);

export function DirtyDraftProvider({ draftsRef, children }) {
  return <DirtyDraftContext.Provider value={draftsRef}>{children}</DirtyDraftContext.Provider>;
}

export function useDirtyDraft(dirty) {
  const draftsRef = useContext(DirtyDraftContext);
  useLayoutEffect(() => {
    if (!dirty || !draftsRef) return undefined;
    const token = {};
    const drafts = draftsRef.current;
    drafts.add(token);
    return () => {
      drafts.delete(token);
    };
  }, [dirty, draftsRef]);
}
